var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.map.name))]),_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Map","active":""}},[_c('div',{attrs:{"id":"mapContainer"}})]),_vm._l((_vm.tabArr),function(item){return _c('b-tab',{key:item.title,attrs:{"title":item.title},domProps:{"innerHTML":_vm._s(item.text)}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }